module.exports = __webpack_public_path__ + "static/img/ddhzyk-img7.d5da0897.jpg";